import { createSlice } from "@reduxjs/toolkit";
import { LoadState } from "../../../constants/enums";
import { initialRiskProfileState } from "./commAutoRiskProfile.types";
import {
  fetchRiskProfileListAsync,
  fetchRiskProfileAsync,
  saveRiskProfileAsync,
} from "./commAutoRiskProfileActions";

const riskProfileSlice = createSlice({
  name: "riskProfile",
  initialState: initialRiskProfileState,
  reducers: {
    clearRiskProfileFormState: (state) => {
      state.form = initialRiskProfileState.form;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRiskProfileListAsync.pending, (state) => {
        state.list.loading = LoadState.InProgress;
        state.list.data = [];
      })
      .addCase(fetchRiskProfileListAsync.fulfilled, (state, action) => {
        state.list.loading = LoadState.Loaded;
        state.list.data = action.payload.data;
      })
      .addCase(fetchRiskProfileListAsync.rejected, (state, action) => {
        state.list.loading = LoadState.Failed;
        state.list.data = [];
        state.list.error = action.payload?.message ?? null;
      })

      .addCase(fetchRiskProfileAsync.pending, (state) => {
        state.form.loading = LoadState.InProgress;
      })
      .addCase(fetchRiskProfileAsync.fulfilled, (state, action) => {
        state.form.loading = LoadState.Loaded;
        state.form.data = action.payload.data;
      })
      .addCase(fetchRiskProfileAsync.rejected, (state, action) => {
        state.form.loading = LoadState.Failed;
        state.form.error = action.payload?.message ?? null;
      })

      .addCase(saveRiskProfileAsync.pending, (state) => {
        state.form.saveLoading = true;
      })
      .addCase(saveRiskProfileAsync.fulfilled, (state, action) => {
        state.form.saveLoading = false;
        state.form.data = action.payload.data;
      })
      .addCase(saveRiskProfileAsync.rejected, (state, action) => {
        state.form.saveLoading = false;
        state.form.loading = LoadState.Failed;
        state.form.error = action.payload?.message ?? null;
      });
  },
});

export const { clearRiskProfileFormState } = riskProfileSlice.actions;
export const riskProfileReducer = riskProfileSlice.reducer;
